import React from "react";

export const AnatomyCSTContext = React.createContext({
  unitInfo: {},
  networkId: null,
  currency: null,
  timezone: null,

  setUnitInfo: () => {},
});
